import { Box, VStack } from "@chakra-ui/react"
import HTMLText from "@pathwright/ux/src/components/text/HTMLText"
import { useCoverPageContext } from "./CoverPageProvider"
import { COVER_PAGE_PADDING } from "./constants"

const CoverPageOverview = () => {
  const { resource } = useCoverPageContext()

  if (!resource?.description) return null

  const { description } = resource

  return (
    <Box
      className="CoverPageOverview"
      w="100%"
      px={COVER_PAGE_PADDING}
      pt={"30px"}
      sx={{
        "ul, ol": {
          paddingLeft: "2em",
          marginBottom: "15px"
        },
        ul: {
          listStyleType: "disc"
        },
        p: {
          margin: 0
        }
      }}
    >
      <HTMLText html={description!} color="PRIMARY_GRAY" w="100%" />
    </Box>
  )
}

export const CoverPageOverviewImmersive = () => {
  return (
    <VStack
      w="full"
      bgColor="backgroundSecondary"
      overflowY="auto"
      borderRadius="card"
      maxHeight="100%"
      maxWidth={{ base: "100%", md: "800px" }}
      margin="0 auto"
      sx={{
        ".CoverPageOverview": {
          paddingBottom: "20px",
          paddingTop: "20px"
        }
      }}
    >
      <CoverPageOverview />
    </VStack>
  )
}

export default CoverPageOverview
